import { render, staticRenderFns } from "./Set_record_information.vue?vue&type=template&id=6f1ddf5e&scoped=true&"
import script from "./Set_record_information.vue?vue&type=script&lang=js&"
export * from "./Set_record_information.vue?vue&type=script&lang=js&"
import style0 from "./Set_record_information.vue?vue&type=style&index=0&id=6f1ddf5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ddf5e",
  null
  
)

export default component.exports